import { Divider, Drawer, List } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import React, { Component } from "react"
import { withRouter } from "react-router-dom"

import OrganizationStore from "../stores/OrganizationStore"
import SessionStore from "../stores/SessionStore"
import Admin from "./Admin"
import NavListItem from "./NavListItem"
import { ADMIN_NAV_ITEMS, NOAUTH_NAV_ITEMS, getOrgNavItems } from "./sideNavConfig"

import theme from "../theme"

const styles = {
  drawerPaper: {
    overflowX: "hidden",
    overflowY: "auto",
    position: "fixed",
    width: 60,
    paddingTop: theme.spacing(9),
  },
  drawerPaperFull: {
    position: "fixed",
    width: 270,
    paddingTop: theme.spacing(9),
  },
  select: {
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
  listItem: {
    "& > a": {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  listItemSmall: {
    "& > a": {
      paddingTop: 4,
      paddingBottom: 4,
    },
  },
}

class SideNav extends Component {
  constructor() {
    super()

    this.state = {
      open: true,
      cacheCounter: 0,
      isGlobalAdmin: false,
    }

    this.onChange = this.onChange.bind(this)
    this.getOrganizationOption = this.getOrganizationOption.bind(this)
    this.getOrganizationOptions = this.getOrganizationOptions.bind(this)
    this.getOrganizationFromLocation = this.getOrganizationFromLocation.bind(this)
    this.getOptionSelected = this.getOptionSelected.bind(this)
  }

  componentDidMount() {
    this.setState({
      isGlobalAdmin: SessionStore.isAdmin(),
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props === prevProps) {
      return
    }
  }

  onChange(e) {
    this.props.history.push(`/organizations/${e.target.value}`)
  }

  getOrganizationFromLocation() {
    const organizationRe = /\/organizations\/(\d+)/g
    const match = organizationRe.exec(this.props.history.location.pathname)

    if (match !== null && (this.props.organization === null || this.props.organization.id !== match[1])) {
      SessionStore.setOrganizationID(match[1])
    }
  }

  getOrganizationOption(id, callbackFunc) {
    OrganizationStore.get(id, (resp) => {
      callbackFunc({ label: resp.organization.name, value: resp.organization.id })
    })
  }

  getOrganizationOptions(search, callbackFunc) {
    OrganizationStore.list(search, 999, 0, (resp) => {
      const options = resp.result.map((o) => {
        return { label: o.name, value: o.id }
      })
      callbackFunc(options, resp.totalCount)
    })
  }

  getOptionSelected(option, value) {
    if (!value) {
      return true
    }
    return option.value === value.value
  }

  render() {
    const { size, mode, organization, classes, open, location } = this.props
    const listClassName = size === "full" ? classes.listItem : classes.listItemSmall
    const orgNavItems = organization ? getOrgNavItems({ organization, isGlobalAdmin: this.state.isGlobalAdmin }) : []
    const pathname = location.pathname

    return (
      <Drawer variant="persistent" anchor="left" open={open} classes={{ paper: size === "full" ? classes.drawerPaperFull : classes.drawerPaper }}>
        {mode === "noauth" && (
          <List>
            {NOAUTH_NAV_ITEMS.map((item) => (
              <NavListItem key={item.to} {...item} size={size} pathname={pathname} />
            ))}
          </List>
        )}

        {mode !== "noauth" && (
          <Admin>
            <List className={listClassName}>
              {ADMIN_NAV_ITEMS.map((item) => (
                <NavListItem key={item.to} {...item} size={size} pathname={pathname} />
              ))}
            </List>
            <Divider />
          </Admin>
        )}

        {organization && mode !== "noauth" && (
          <List className={listClassName}>
            {orgNavItems.map((item) => {
              const navItem = <NavListItem key={item.to} {...item} size={size} pathname={pathname} />

              return item.adminOnly ? (
                <Admin key={item.to} organizationID={organization.id}>
                  {navItem}
                </Admin>
              ) : (
                navItem
              )
            })}
          </List>
        )}
      </Drawer>
    )
  }
}

export default withRouter(withStyles(styles)(SideNav))
